import { Status } from '@philo/web-shared';

export interface DeviceAuthState {
  code: string;
  isActivatingDevice: boolean;
  isValidatingCode: boolean;
  redirectURL: string;
  status?: Status;
  validationError: string;
}

const initialState: DeviceAuthState = {
  code: '',
  isActivatingDevice: false,
  isValidatingCode: false,
  redirectURL: '',
  status: undefined,
  validationError: '',
};

export default initialState;
